import { useQuery } from "@tanstack/react-query";
import { useScopeParams } from "./useScopeParams";
import { alertsService } from "@/services/alertsService";

export type AlertEvaluation = {
  evaluated_at: string;
  condition_is_met: boolean;
  condition_met_detail: string | null;
};

export const useAlertHistoryQuery = (
  alertId?: string,
  enabled: boolean = true,
) => {
  const { id } = useScopeParams();

  const query = useQuery({
    queryKey: ["alert-history", id, alertId],
    queryFn: async (): Promise<AlertEvaluation[]> => {
      if (!id || !alertId) return [];
      return alertsService.getAlertHistory(id, alertId);
    },
    enabled: enabled && !!id && !!alertId,
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });

  return {
    evaluations: query.data || [],
    isLoading: query.isLoading,
    error: query.error,
  };
};
